var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Watch } from 'vue-property-decorator';
import { getVideosCRM } from '@/shared/utils/Infosets.utils';
import { NotificationService } from '@/services/NotificationService';
import { verifyPipedriveToken } from '@/clients/crm';
import Modal from 'components/Modal.vue';
import Tooltip from 'components/Tooltip.vue';
import CrmCardContent from 'components/CrmCardContent.vue';
let PipedriveConfigCard = class PipedriveConfigCard extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.token = '';
        this.tokenVerified = false;
        this.ocultedToken = true;
        this.openModal = false;
        this.crmIcon = 'statics/images/logos/pipedrive-logo.png';
        this.companyFields = [
            'Razão Social',
            'Nome Fantasia',
            'CNPJ',
            'Endereço',
            'CNAE Principal',
            'CNAE Secundário',
            'Quadro Societário',
            'Setor',
            'Todos os Telefones',
            'Todos os Emails',
            'Data de Abertura',
            'Situação CNPJ',
            'Faixa de Faturamento da Unidade CNPJ',
            'Faixa de Funcionários da Unidade CNPJ',
            'Endereço na Web',
            'Administrador',
            'Decisores',
            'Emails Principais',
            'Telefones Principais',
        ];
        this.decisorFields = [
            'Nome',
            'E-mail',
            'Empresa',
            'Posição',
            'Nível de decisão',
            'Link do linkedIn',
        ];
        this.questions = [
            {
                question: 'Quais planos permitem exportação?',
                answer: 'Todos os planos pagos',
            },
            {
                question: 'Qual nível de permissão meu usuário precisa ter?',
                answer: 'O usuário precisa ter permissão de admin em "Global features"',
            },
            {
                question: 'Qual o limite de planos customizados?',
                answer: `
        Plano Essencial: 30 /
        Plano Avançado: 100 /
        Plano Profissional: 300 /
        Plano Power: 500 /
        Plano Corporativo: ilimitado
      `,
            },
            {
                question: 'Onde encontrar os dados das empresas?',
                answer: 'No menu lateral esquerdo vai em Contatos e depois em Organizações.',
            },
            {
                question: 'Onde encontrar os dados dos decisores?',
                answer: 'No menu lateral esquerdo vai em Contatos e depois em Pessoas.',
            },
            {
                question: 'O que acontece se eu exportar 2 vezes a mesma empresa?',
                answer: 'Nosso integrador irá duplicar as empresas e seus contatos',
            },
        ];
        this.observations = [
            'Sua conta deverá capacidade para criar 19 campos, para que o envio de dados ocorra com sucesso.',
        ];
    }
    changedOpenModal() {
        this.ocultedToken = true;
    }
    async verifyToken() {
        this.loading = true;
        try {
            await verifyPipedriveToken({ token: this.token });
            this.tokenVerified = true;
            this.ocultedToken = true;
            NotificationService.success('Sucesso', 'Seu token foi salvo com sucesso. Agora você pode exportar para o crm!');
        }
        catch (e) {
            NotificationService.error('Error', 'O token selecionado está inválido');
        }
        this.loading = false;
    }
    get tutorialVideoLink() {
        return getVideosCRM('pipedrive');
    }
    tooltipText() {
        const message = `<li>Exportar até 400 empresas sem ou com poucos decisores;</li>
            <li>Exportar até 300 decisores com no máximo 150 empresas;</li>
            <li>Possuir permissões habilitadas para conta comum ou manager do Pipedrive.</li>
            `;
        return message;
    }
    changeToken() {
        this.token = '';
        this.tokenVerified = false;
    }
};
__decorate([
    Watch('openModal')
], PipedriveConfigCard.prototype, "changedOpenModal", null);
PipedriveConfigCard = __decorate([
    Component({
        name: 'PipedriveConfigCard',
        components: {
            Modal,
            Tooltip,
            CrmCardContent,
        },
    })
], PipedriveConfigCard);
export default PipedriveConfigCard;
